import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from 'api/base';
import type { ResultData } from 'types/result';

export type SaveResult = ReturnType<typeof useUpdateResult>['mutateAsync'];

export function useUpdateResult(id: number) {
  const queryClient = useQueryClient();

  const mutationKey = ['updateResult', id];

  return useMutation({
    mutationKey,
    scope: { id: `result-${id}` },
    mutationFn: (fieldToUpdate: Record<string, unknown>) =>
      put('updateResult', fieldToUpdate, id) as Promise<ResultData | null>,
    onSuccess: (saved) => {
      const queued = queryClient.getMutationCache().findAll({ mutationKey, status: 'pending' });
      if (saved && queued.length <= 1) {
        queryClient.setQueryData<ResultData>(['conversation', id], saved);
      }
    },
  });
}
